import { Form, Input } from 'antd';
import { ConfigSvcProps } from '..';
import { useSvcDisabled } from '../hook/useSvcDisabled';

const { TextArea } = Input;

const CommonJobSvcInstructions = (props: ConfigSvcProps) => {
  const { jobOptionSvc, id } = props;

  const svcDisabled = useSvcDisabled(props);

  return (
    <>
      {/* className={`${svcDisabled ? 'jobconfig-jobOption-content-disabled' : ''}`} */}
      {Boolean(jobOptionSvc?.showInstructions) && (
        <>
          <div className={`jobconfig-jobOption-content-label`}>
            instructions
          </div>

          <div className={`jobconfig-jobOption-textArea`}>
            <Form.Item name={[id, 'instructions']} noStyle>
              <TextArea
                disabled={svcDisabled}
                placeholder="Type instructions here"
              />
            </Form.Item>
          </div>
        </>
      )}
    </>
  );
};

export default CommonJobSvcInstructions;
